// extracted by mini-css-extract-plugin
export default {"navLinkList":"navigation_navLinkList__D1T5v","navLinkItem":"navigation_navLinkItem__fdRrn"};